import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GerenciarSaidaCaixaComponent } from './gerenciar-saida-caixa.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: GerenciarSaidaCaixaComponent}
  ])],
  exports: [RouterModule]
})
export class GerenciarSaidaCaixaRoutingModule { }
